import Image from 'next/image';

const ServicesOfferSection = ({
  topHeading,
  mainHeading,
  highlight,
  description,
  services,
  highlightfirst
}) => {
  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#172554] lg:px-20 lg:py-20 px-10 py-10 font-inter max-w-[1750px] mx-auto">
      <div className="flex flex-col justify-center items-center gap-y-16 w-full">

        {/* Headings */}
        <div className="flex flex-col justify-center items-center gap-y-4">
          <h3 className="text-white text-base font-inter font-normal !leading-[20px] uppercase">
            {topHeading}
          </h3>
          <h2 className="text-white md:text-center text-2xl lg:text-5xl font-inter font-bold lg:!leading-[150%] w-full">
            {highlightfirst && <span className="text-[#046DEB]">{highlightfirst}</span>}
            {mainHeading}{" "}
            {highlight && <span className="text-[#046DEB]">{highlight}</span>}
          </h2>
          <p className="text-[#FFFFFF] md:text-center text-base lg:text-lg font-normal leading-7 lg:tracking-[-0.16px] lg:max-w-[1280px] w-full px-3">
            {description}
          </p>
        </div>

        {/* Responsive Staggered/Overlapping Cards */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-4 ">
          {services &&
            services.map((item, index) => (
              <div
                key={index}
                className={`
                  grid flex-col items-center max-w-xl  px-6 py-6 gap-3 
                    shadow-lg 
                  transition-transform duration-300 hover:-translate-y-3
                   
                `}
              >
                <div className="w-full flex flex-row items-center gap-x-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FFFFFF33] rounded-md p-2 ">
                    <Image
                      src={item.icon}
                      alt={item.title}
                      width={40}
                      height={40}
                      className="object-contain"
                    />
                  </div>
                  <h4 className="text-[#FFFFFF] text-lg md:text-xl font-bold !leading-[120%] !tracking-[-0.16px]">
                    {item.title}
                  </h4>
                </div>
                <div className="w-full text-white text-sm font-inter font-semibold leading-[150%]">
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesOfferSection;
